import PropTypes from 'prop-types';
import React from 'react';
import { useRouteError } from 'react-router';

import ErrorBoundaryContainer from './ErrorBoundaryContainer';

/**
 * The root route's errorElement (CORE-78999).
 *
 * A data router installs an error boundary around the root match whether or not any route declares
 * an errorElement -- react-router's RenderedRoute does it whenever dataRouterState is set. Left to
 * itself it catches client render errors first and renders its own page ("Unexpected Application
 * Error!", the message and the JS stack, in the production build too), and ErrorBoundaryContainer
 * above RouterProvider never runs. Re-raising inside a fresh ErrorBoundaryContainer hands the error
 * back to the app's own boundary, so there is one error page rather than two.
 *
 * Lives here rather than in ApplicationRouter so the shared test helper can attach it to its own
 * memory router without importing the whole route tree.
 */
function Rethrow({ error }) {
  throw error;
}

Rethrow.propTypes = {
  error: PropTypes.instanceOf(Error).isRequired
};

export default function RouteErrorElement() {
  const error = useRouteError();

  return (
    <ErrorBoundaryContainer>
      <Rethrow error={error} />
    </ErrorBoundaryContainer>
  );
}
